export const maxTableWidth = 550;
